import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDeleteClientMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { useNotifyMessages } from 'api/helpers/useNotifyMessages';

export const useDeleteClient = () => {
  const [handle, { loading, error: apolloError }] = useDeleteClientMutation();
  const notifyMessage = useNotifyMessages();

  const error = useError(apolloError);

  return {
    loading,
    error,
    deleteClient: useCallback(
      async (id: string) => {
        const res = await handle({
          variables: {
            id,
          },
        });

        notifyMessage(res.data?.deleteClient?.messages);

        return res.data?.deleteClient?.data;
      },
      [handle, notifyMessage]
    ),
  };
};
